import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

/**
 * どんな値が渡されても普通にViewを表示する
 * ダミーのDirective
 * 入力された値を変数に格納するために使う
 */
@Directive({
  selector: '[appDummy]'
})
export class DummyDirective {
  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef) { }
  /**
   *
   */
  @Input() set appDummy(val: any) {
    // 初期化しないとcreateEmbeddedView()で実行の度に要素が増えていく
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
